module.exports = __webpack_public_path__ + "img/CREE.634915d3.png";